/**
 * AboutENDemoChecksFetcherView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait AboutENDemoChecksFetcher
 */

import { useAboutENDemoChecksFetcherLogic } from '@/hooks/traits/useAboutENDemoChecksFetcherLogic';
import type { AboutENDemoChecksFetcherConfig } from '@/hooks/traits/useAboutENDemoChecksFetcherLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { AboutENDemoCheck } from '@app/shared';
import { Alert } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';
import { useTranslate } from '@almadar/ui/hooks';

interface AboutENDemoChecksFetcherViewProps {
  config?: Partial<AboutENDemoChecksFetcherConfig>;
}

export function AboutENDemoChecksFetcherView({ config: propsConfig }: AboutENDemoChecksFetcherViewProps) {
  const { t: __t, locale: __locale } = useTranslate();
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useAboutENDemoChecksFetcherLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['AboutENDemoCheck'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="AboutEN" trait="AboutENDemoChecksFetcher">
      <UISlotComponent slot="toast" pattern={slotWriter['toast'] === 'ChecksLoadFailed' ? "alert" : "clear"} sourceTrait="AboutENDemoChecksFetcher">{slotWriter['toast'] === 'ChecksLoadFailed' ? (<Alert variant="error" message={String(__t("std-almadar-demo-checks:checks.failed"))} />) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default AboutENDemoChecksFetcherView;
